<template>
  <div v-if="params.value" class="text-center">
    <a v-if="params.value" :href="params.data.check_anchor" target="_blank">
      {{ params.value }}
    </a>
    <div v-else>-</div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "PaymentCheck",
});
</script>

<style scoped>

</style>
